import React, {PropTypes} from 'react';
import FormInput from './forminput.react';
import TimePicker from 'react-time-picker';

export default class TimepickInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string.isRequired
  }

  onChange(value) {
    const {action, name} = this.props;
    action({target: {name, value}});
  }

  render() {
    const {label, value} = this.props;

    return (
      <div className="form-group">
        <div className="cms-dateTimePicker">
          {label &&
            <label>{label}</label>
          }
          <div className="form-group">
            <TimePicker
              value={value}
              onChange={::this.onChange}
              format="hh:mm A"
              minuteStep={15}
              style={{border: 'none'}}
              arrowStyle={{color: '#e75f87'}}/>
          </div>
        </div>
      </div>
    );
  }
}
